/**
 * Supabase üzerinden turnuva ve maç listesi / tek maç çekme (REST API).
 * Tablolar: tournaments (id, name, ...), matches (id, tournament_id, title, replay_json, ...)
 */

import { isSupabaseConfigured, supabaseGet } from './supabase'

export { isSupabaseConfigured }

function sortByName(a, b) {
    const na = (a.name || a.title || '').toLowerCase()
    const nb = (b.name || b.title || '').toLowerCase()
    return na.localeCompare(nb)
}

export async function fetchTournaments() {
    const { data, error } = await supabaseGet('tournaments', {
        select: '*',
        order: 'name.asc',
    })
    if (error || !data) return null
    return Array.isArray(data) ? data.sort(sortByName) : []
}

export async function searchTournaments(query) {
    if (!query || !String(query).trim()) return fetchTournaments()
    const { data, error } = await supabaseGet('tournaments', {
        select: '*',
        ilike: { name: '%' + String(query).trim() + '%' },
        order: 'name.asc',
    })
    if (error || !data) return null
    return Array.isArray(data) ? data.sort(sortByName) : []
}

export async function fetchMatchesByTournament(tournamentId) {
    if (!tournamentId) return null
    const { data, error } = await supabaseGet('matches', {
        select: 'id,title,match_date,map_name,created_at',
        eq: { tournament_id: tournamentId },
        order: 'created_at.asc',
    })
    if (error || !data) return null
    const list = Array.isArray(data) ? data : []
    list.sort((a, b) => new Date(a.created_at || 0) - new Date(b.created_at || 0))
    return list
}

function getStoragePublicUrl(path) {
    const url = process.env.REACT_APP_SUPABASE_URL || ''
    const base = url.replace(/\/$/, '')
    const bucket = 'replays'
    return base + '/storage/v1/object/public/' + encodeURIComponent(bucket) + '/' + encodeURIComponent(path)
}

export async function fetchMatchReplay(matchId) {
    if (!matchId) return null
    const { data, error } = await supabaseGet('matches', {
        select: 'replay_json,replay_storage_path,title,map_name',
        eq: { id: matchId },
    })
    if (error || !data) return null
    const row = Array.isArray(data) ? data[0] : data
    if (!row) return null

    let replay
    if (row.replay_storage_path) {
        const res = await fetch(getStoragePublicUrl(row.replay_storage_path))
        if (!res.ok) return null
        replay = await res.json()
    } else if (row.replay_json != null) {
        replay = row.replay_json
    } else {
        return null
    }
    return { replay, map_name: row.map_name || null }
}

export async function fetchMatchMeta(matchId) {
    if (!matchId) return null
    const { data, error } = await supabaseGet('matches', {
        select: 'id,title,tournament_id,created_at',
        eq: { id: matchId },
    })
    if (error || !data) return null
    return Array.isArray(data) ? data[0] : data
}



// WEBPACK FOOTER //
// ./src/lib/supabaseApi.js